if (process.env.NODE_ENV === "production") {
  const obj = JSON.parse(localStorage.getItem("$myconfig"));
  const __webpack_public_path__ = obj.publicPath;
}
